import {
  amethyst100,
  amethyst500,
  astronaut200,
  astronaut600,
  blackPearl200,
  blackPearl600,
  purpleHeart200,
  purpleHeart600,
  riptide100,
  riptide400
} from "@/styles/colors"

// ASSETS
import iconExploring from "@/assets/icons/icon-telescope-exploring.svg"
import iconIdentifying from "@/assets/icons/icon-lightbulb-identifying.svg"
import iconPreparing from "@/assets/icons/icon-profile-study-preparing.svg"
import iconApplying from "@/assets/icons/icon-pen-applying.svg"
import iconSucceeding from "@/assets/icons/icon-trophy-succeeding.svg"
import iconExploringGrey from "@/assets/icons/icon-telescope-exploring-grey.svg"
import iconIdentifyingGrey from "@/assets/icons/icon-lightbulb-identifying-grey.svg"
import iconPreparingGrey from "@/assets/icons/icon-profile-study-preparing-grey.svg"
import iconApplyingGrey from "@/assets/icons/icon-pen-applying-grey.svg"
import iconSucceedingGrey from "@/assets/icons/icon-trophy-succeeding-grey.svg"

// TYPES
import { CareerStageData } from "@/types/careerStageData"

export const careerStageData: CareerStageData = {
  exploring: {
    index: 0,
    label: "Exploring",
    icon: iconExploring,
    iconGrey: iconExploringGrey,
    color: amethyst500,
    lightColor: amethyst100,
    text: "Understanding your interests, strengths, and values to discover career paths that align with your goals."
  },
  identifying: {
    index: 1,
    label: "Identifying",
    icon: iconIdentifying,
    iconGrey: iconIdentifyingGrey,
    color: purpleHeart600,
    lightColor: purpleHeart200,
    text: "Narrowing down specific roles or industries that match your skills and aspirations."
  },
  preparing: {
    index: 2,
    label: "Preparing",
    icon: iconPreparing,
    iconGrey: iconPreparingGrey,
    color: astronaut600,
    lightColor: astronaut200,
    text: "Building the necessary skills, crafting a strong resume, and practicing for interviews."
  },
  applying: {
    index: 3,
    label: "Applying",
    icon: iconApplying,
    iconGrey: iconApplyingGrey,
    color: blackPearl600,
    lightColor: blackPearl200,
    text: "Actively searching for jobs, submitting applications, and networking."
  },
  succeeding: {
    index: 4,
    label: "Succeeding",
    icon: iconSucceeding,
    iconGrey: iconSucceedingGrey,
    color: riptide400,
    lightColor: riptide100,
    text: "Thriving in your new role by setting goals, developing professionally, and ensuring long-term career growth."
  }
}
